import { render, staticRenderFns } from "./tmallorder.vue?vue&type=template&id=487c1e7d&scoped=true&"
import script from "./tmallorder.vue?vue&type=script&lang=js&"
export * from "./tmallorder.vue?vue&type=script&lang=js&"
import style0 from "./tmallorder.vue?vue&type=style&index=0&id=487c1e7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c1e7d",
  null
  
)

export default component.exports